<template>
  <div class="">
    <div class="modal-dialog modal-xl" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ title }}</h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            @click="cancel"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form>
            <div class="form-group">
              <label for="email">email</label>
              <input
                type="text"
                class="form-control"
                id="email"
                placeholder="email"
                v-model="email"
              />
            </div>
            <div class="form-group">
              <label for="firstName">Vorname</label>
              <input
                type="text"
                class="form-control"
                id="firstName"
                placeholder="firstName"
                v-model="firstName"
              />
            </div>
            <div class="form-group">
              <label for="lastName">Name</label>
              <input
                type="text"
                class="form-control"
                id="lastName"
                placeholder="lastName"
                v-model="lastName"
              />
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <div class="row mx-auto">
            <div class="col-xs-6 mx-1">
              <button
                @click="save()"
                type="button"
                class="btn btn-outline-dark btn-block"
              >
                <i class="far fa-save"></i>&nbsp;Speichern
              </button>
            </div>
            <div class="col-xs-6 mx-1">
              <button
                @click="cancel()"
                type="button"
                class="btn btn-outline-dark btn-block"
                data-dismiss="modal"
              >
                <i class="far fa-times-circle"></i>&nbsp;Abbrechen
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "timeTrackingUser",
  data: function() {
    return {
      email: "",
      lastName: "",
      firstName: "",
      title: "Neuen Zeiterfassung Benutzer erfassen"
    };
  },
  methods: {
    save() {
      this.$emit("save", {
        email: this.email,
        firstName: this.firstName,
        lastName: this.lastName
      });
    },
    cancel() {
      this.$emit("cancel");
    }
  },
  props: []
};
</script>
